const requestMicrophonePermission = async () => {
  const permission = await navigator.mediaDevices
    .getUserMedia({ audio: true })
    .then((streamTest) => {
      // Stopping all tracks because we only need permission at this stage
      streamTest.getTracks().forEach((track) => {
        track.stop();
        // eslint-disable-next-line no-param-reassign
        track.enabled = false;
      });

      return true;
    })
    .catch(() => false);

  return permission;
};

const getMicrophonePermission = async () => {
  try {
    const permission = await navigator.permissions.query({
      name: 'microphone',
    });

    if (permission.state === 'denied' || permission.state === 'prompt')
      return false;

    return true;
  } catch (error) {
    return false;
  }
};

export { requestMicrophonePermission, getMicrophonePermission };
